module.exports = __webpack_public_path__ + "img/w3_question_grey.bddb381d.png";